import React, { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalComponent } from 'new/routes/RouterManager';
import styles from './DataCustodians.module.scss';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import { showAlert } from 'new/stores/showAlert/action';
import { useOrgMembers } from 'new/hooks/adapters/useOrgMembers';
import { useModals } from 'new/hooks/useModals';
import { addOrgCustodian } from 'js/actions';
import { useOrgCustodians } from 'new/hooks/adapters/useOrgCustodians';
import { SelectOption } from 'js/components/elements/rselect/ReactSelectUtils';

interface ModalAddOrgCustodianProps {}

export const ModalAddOrgCustodian: ModalComponent = (
  props: ModalAddOrgCustodianProps & ModalOutProps,
) => {
  const { setModalActions } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const { id: orgId } = useCurrentOrg();
  const members = useOrgMembers({ orgId });
  const { closeModal } = useModals();
  const currentOrgCustodians = useOrgCustodians();
  const memberEmails = members
    .filter((member) => !(member.id in currentOrgCustodians))
    .map((member) => ({
      label: member?.email,
      value: member?.id,
    }));
  const [selectedMember, setSelectedMember] = useState({});

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Save',
        onClick: onSubmit,
        disabled: isEmpty(selectedMember),
      },
    });
  }, [selectedMember]);

  const onChangeMember = (option) => {
    setSelectedMember(option);
  };

  const onSubmit = () => {
    dispatch(addOrgCustodian(orgId, selectedMember?.value)).then(() => {
      closeModal(ModalAddOrgCustodian.modalConfig.name);
      dispatch(
        showAlert({
          title: `Custodian added successfully!`,
          severity: 'success',
        }),
      );
    });
  };

  return (
    <div>
      <Stack gap="16px">
        <Typography>Select a Member</Typography>
        <Select
          options={memberEmails}
          value={selectedMember}
          onChange={onChangeMember}
          components={{ Option: SelectOption }}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 1300 }),
          }}
        />
      </Stack>
    </div>
  );
};

ModalAddOrgCustodian.modalConfig = {
  name: 'ModalAddOrgCustodian',
  title: 'Add Org Custodian',
  rootClassName: styles.rootModalContainer,
  contentClassName: styles.contentModalContainer,
  fullWidth: true,
  maxWidth: 'sm',
};
